export const totalNumber = (number) => {
  const splittedNumber = number.split(' ')
  return (splittedNumber[0].slice(3, -1) + splittedNumber[1] + splittedNumber[2] + splittedNumber[3]).replace(/[^0-9]/g,"")
}
export const inputNumber = (number) => `+7(${number.slice(0, 3)}) ${number.slice(3, 6)} ${number.slice(6, 8)} ${number.slice(8, 10)}`
